import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from "rxjs";
import {UserRoles} from "../user/user-roles";
import {RouteData} from "../shared/services/route-data/route-data";
import * as fromStore from '../store';
import {filter, first, switchMap} from "rxjs/operators";
import {User} from '../user/user';
import {DbStoreState} from '../store/reducers';
import {Store} from '@ngrx/store';
import {UserService} from '../user/user.service';
import {UserSubscriptionIds, UserSubscriptionType} from "../../app/user/user-subscription";

@Injectable()
export class BuilderSignoutGuard implements CanActivate {

  private subscriptionId: number;
  private currentSubscriptionId: number;
  private subscriptionType: any;
  public userSubscriptionIds: any = UserSubscriptionIds;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _store: Store<DbStoreState>,
    private _userService: UserService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>((resolve, reject) => {
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getUser)),
          first()
        )
        .subscribe((user: User) => {
          const role: string = user ? UserRoles.user : UserRoles.guest;
          const routeData: RouteData = new RouteData(next.data);
          const isAuthorized: boolean = routeData.roles.indexOf(role) !== -1 || routeData.roles.indexOf(UserRoles.all) !== -1;
          const queryParams: any = next.queryParams;
          this.subscriptionId = parseInt(queryParams.subscr_id, 10);
          this.currentSubscriptionId = user && user.subscriptionId;

          this.subscriptionType = user && user.planType;
          if (this.subscriptionId && (this.currentSubscriptionId === this.userSubscriptionIds.TRIAL || this.currentSubscriptionId === this.userSubscriptionIds.TRIAL_OPTIMIZER)) {
            resolve(false);
            this._router.navigate(['/checkout'], { queryParams: { 'subscr_id': this.subscriptionId } });
          }
          else if (this.subscriptionType === UserSubscriptionType.ONE_PRODUCT || (this.subscriptionType === UserSubscriptionType.FREE && this.currentSubscriptionId === this.userSubscriptionIds.TRIAL) || this.subscriptionType === UserSubscriptionType.PREMIUM) {
            resolve(true);
          }
          else {
            resolve(false);
            this._router.navigate(['/websites']);
          }

          if (isAuthorized) {
            resolve(true);
            return;
          }

          resolve(false);
        });
    });
  }

}
